import { el, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

class InputRenderer {

  renderInput() {

    this.input = el('input.checkbox-group-option-input', {
      type: this.inputType,
      required: this.inputGroup.inputOptions.required,
      onchange: this.handleInputStateChange.bind(this)
    });

    return this.input;

  }

  renderLabel() {

    this.labelSpan = el('span');
    this.label = el('label.checkbox-group-option-label', [
      this.renderInput(),
      this.labelSpan
    ]);

    return this.label;

  }

  handleInputStateChange() {

    const values = this.inputGroup.getValue();

    if (values.length === 0) {
      this.inputGroup.trySetRequired();
    } else {
      this.inputGroup.tryUnsetRequired();
    }

  }

  updateLabel(option) {

    this.labelSpan.textContent = option;

  }

  updateInput(option, fieldRow) {

    setAttr(this.input, {
      name: `${fieldRow.label}[]`
    });

  }

  setRequired(required) {

    setAttr(this.input, {
      required
    });

  }

  update(option, index, options, action) {

    if (action.type === 'setRequired') {

      this.setRequired(action.value);

    } else {

      this.updateLabel(option);

      this.updateInput(option, action.value);

    }

  }

}

export default InputRenderer;